import { UPDATE_CART } from "./actionTypes";
import { formatPrice } from "../../components/helpers/formatPrice";

export const updateCart = cartProducts => dispatch => {
	let productQuantity = cartProducts.reduce((sum, p) => {
		// sum += p.quantity;
		sum++;
		return sum;
	}, 0);
	let discountPrice = 0;
	let totalPrice = cartProducts.reduce((sum, p) => {
		let addonTotal = 0;
		
		if(p.discount){
			// console.log(parseFloat(parseFloat(p.price)*(parseInt(p.discount)/100)).toFixed(2));
			// discountPrice += (parseFloat(parseFloat(p.price)*(parseInt(p.discount)/100)).toFixed(2)) * p.quantity; 
			discountPrice = (parseFloat(parseFloat(p.price)*(parseInt(p.discount)/100)).toFixed(2)); 
			sum +=  (p.price - discountPrice) * p.quantity;
			discountPrice = 0;
		}else{
			sum += p.price * p.quantity;
		}
		sum = parseFloat(sum);
		formatPrice(sum);
		return sum;
	}, 0);

	let cartTotal = {
		productQuantity,
		totalPrice,
		discountPrice
	};

	dispatch({
		type: UPDATE_CART,
		payload: cartTotal
	});
};
